
import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import {durationToStr} from 'shared';

@Component({
  selector: 'app-fields-interventions-fuel-consumption-per-operation-report',
  templateUrl: './fields-interventions-fuel-consumption-per-operation-report.component.html',
  styleUrls: ['./fields-interventions-fuel-consumption-per-operation-report.component.scss']
})
export class FieldsInterventionsFuelConsumptionPerOperationReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      allowFiltering: true,
      width: 150,
      area: 'row'
    }, {
      caption: 'Parcelle',
      dataField: 'field.name',
      allowFiltering: true,
      width: 150,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Consommation Carburant L',
      dataField: 'metrics.fuel_total_consumption_all',
      dataType: 'number',
      format: {type: 'fixedPoint', precision: 2},
      summaryType: 'sum',
      area: 'data'
    }, {
      caption: 'Consommation Carburant L/Ha',
      dataField: 'fuel_total_consumption_per_hectare',
      dataType: 'number',
      format: {type: 'fixedPoint', precision: 2},
      summaryType: 'avg',
      area: 'data'
    }, {
      caption: 'Consommation Carburant  L/h',
      dataField: 'metrics.fuel_hourly_consumption_rate_avg_all',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Carburant  Temperature',
      dataField: 'metrics.fuel_temperature_avg_all',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Heures Moteurs',
      dataField: 'metrics.engine_working_time_all',
      dataType: 'number',
      summaryType: 'sum',
      format: durationToStr,
      area: 'data'
    }]);

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'splitAxes',
      alternateDataFields: false,
      inverted: true,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.originalValue.toFixed(2)
    };
  }
}
